<div fxLayout="column" fxLayoutGap="22px" style="padding: 32px;position: relative;">
    <div fxLayoutGap="12px" class="flex justify-between ">
        <div class=" flex align-center">

            <img src="{{headerUrl}}" class="header_image">
            <div class="ml_24 text">
                <div class="text_1">{{user.firstName}} {{user.lastName}} </div>
                <div class="text_2">{{user.roles[0].role}}</div>
            </div>
        </div>
        <img src="./assets/images/black/close.png" style="width: 13px;height:13px" (click)="cancel()">
        <!-- <span (click)="cancel()" class="fc_DEDEDE close-icon">close</span> -->
        <!-- <mat-icon style="width:14px;height:14px;font-size:14px" (click)="cancel()">close</mat-icon> -->
    </div>
    <div fxLayout="column" class="account-menu">
        <div class="account-menu-item" (click)="openEditProfileDialog()">
            <div class="text">Edit profile</div>
        </div>
        <div class="account-menu-item" (click)="toEditCompany()">
            <div class="text">Company profile</div>
        </div>
        <div class="account-menu-item" routerLink="/profile">
            <div class="text">Need some help?</div>
        </div>
    </div>
    <div style="position: fixed;bottom: 10px;">
        <div class="account-menu-item" (click)="logout()" style="color: #494949">
            <div class="text">Log out</div>
        </div>
    </div>
</div>